// TEEKAY LLC Creative Agency - Mock Data

export const companyInfo = {
  name: "TEEKAY LLC",
  tagline: "Creative Digital Agency",
  address: "iLlia Vekua Street, 48 Gldani Tbilisi, 0167, Georgia",
  phone: "+995593107129",
  email: "info@teekayllc.com"
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Service", path: "/services" },
  { name: "Projects", path: "/projects" },
  { name: "Blogs", path: "/blogs" }
];

export const services = [
  {
    id: 1,
    title: "UI/UX Design",
    description: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking consultancy service tailored to.",
    icon: "ux"
  },
  {
    id: 2,
    title: "App Design",
    description: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking consultancy service tailored to.",
    icon: "app"
  },
  {
    id: 3,
    title: "Branding",
    description: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking consultancy service tailored to.",
    icon: "branding"
  },
  {
    id: 4,
    title: "Web app development",
    description: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking consultancy service tailored to.",
    icon: "webapp"
  },
  {
    id: 5,
    title: "Web Design",
    description: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic and forward-thinking consultancy service tailored to.",
    icon: "webdesign"
  }
];

export const projects = [
  {
    id: 1,
    title: "Proton Marketplace",
    category: "SaaS Product",
    description: "A vibrant digital marketplace platform with modern UI",
    image: "https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?w=800&q=80",
    tags: ["UI/UX Design", "Web App"],
    featured: true
  },
  {
    id: 2,
    title: "Active Shop",
    category: "Website",
    description: "E-commerce platform for sports and fitness gear",
    image: "https://images.unsplash.com/photo-1627542557169-5ed71c66ed85?w=800&q=80",
    tags: ["Web Design", "E-commerce"],
    featured: true
  },
  {
    id: 3,
    title: "Credit Line App",
    category: "Mobile App",
    description: "Fintech application for seamless credit management",
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=800&q=80",
    tags: ["App Design", "Branding"],
    featured: true
  },
  {
    id: 4,
    title: "Mega Markdown",
    category: "Web Apps",
    description: "Developer tool for markdown editing and preview",
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&q=80",
    tags: ["Web App", "Developer Tools"],
    featured: true
  },
  {
    id: 5,
    title: "Private Bank",
    category: "Mobile App",
    description: "Secure banking application with premium features",
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=800&q=80",
    tags: ["App Design", "Fintech"],
    featured: false
  },
  {
    id: 6,
    title: "Simple Shopping",
    category: "SaaS Product",
    description: "Minimalist shopping experience platform",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80",
    tags: ["UI/UX Design", "E-commerce"],
    featured: false
  }
];

export const projectCategories = [
  "All Project",
  "SaaS Product",
  "Web Apps",
  "Mobile App",
  "Single Project",
  "Redesign",
  "Website"
];

export const workProcess = [
  {
    id: 1,
    title: "Business Strategy",
    description: "Understanding your business goals and defining the path to success through strategic planning and market analysis."
  },
  {
    id: 2,
    title: "Research",
    description: "Deep dive into user needs, market trends, and competitive landscape to inform design decisions."
  },
  {
    id: 3,
    title: "Define",
    description: "Establishing clear objectives, user personas, and project requirements for focused execution."
  },
  {
    id: 4,
    title: "Design",
    description: "Creating beautiful, functional designs that align with your brand and delight your users."
  },
  {
    id: 5,
    title: "Evaluate",
    description: "Testing, iterating, and refining to ensure the final product exceeds expectations."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alex Thompson",
    company: "TechStart Inc.",
    content: "Wow, that's great! This is what I want, you guys are best agency I work with. I recommended you to my friends and colleagues.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80"
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    company: "InnovateCo",
    content: "Working with TEEKAY LLC was a game-changer for our brand. They understood our needs and delivered a stunning website that truly represents who we are.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "UI/UX Design",
    excerpt: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&q=80",
    date: "Aug 15, 2025",
    category: "Design"
  },
  {
    id: 2,
    title: "Mobile-First Design Today",
    excerpt: "Elevate Youth: A Consultancy Venture for Tomorrow's Leaders is a dynamic",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    date: "Aug 10, 2025",
    category: "Strategy"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much does a UI/UX design project cost?",
    answer: "Project costs vary based on scope, complexity, and timeline. We provide custom quotes after understanding your specific needs. Contact us for a free consultation and detailed estimate."
  },
  {
    id: 2,
    question: "How much does a UI/UX design project cost?",
    answer: "Timelines depend on project complexity. A simple website might take 4-6 weeks, while complex applications can take 3-6 months. We'll provide a detailed timeline during our initial consultation."
  },
  {
    id: 3,
    question: "How much does a UI/UX design project cost?",
    answer: "Yes! We offer various support and maintenance packages to ensure your product continues to perform optimally after launch."
  },
  {
    id: 4,
    question: "How much does a UI/UX design project cost?",
    answer: "Our process includes discovery, research, design, development, testing, and launch phases. We maintain close communication throughout to ensure alignment with your vision."
  }
];

export const clients = [
  { id: 1, name: "LOGOIPSUM" },
  { id: 2, name: "Logoipsum" },
  { id: 3, name: "logoipsum" },
  { id: 4, name: "logoipsum" },
  { id: 5, name: "logoipsum" }
];
